import React from 'react';
import { normalizePremiumFolderData } from '../../utils/normalizePremiumFolderData';
import HiddenDumbView from './Hidden';
import PremiumDumbView from './Premium';
import { DumboProps } from './types';
import { useDeviationMatureFilter } from '../../utils/hooks/useDeviationMatureFilter';

export function useDumboCommon(props: DumboProps) {
  const { showBlocked } = useDeviationMatureFilter(props.deviation);

  if (!props.deviation) {
    return null;
  }

  if (showBlocked && !props.showMatureContent) {
    return <HiddenDumbView {...props} />;
  }

  const { isPremiumLocked } = normalizePremiumFolderData(
    props.deviation?.premiumFolderData
  );

  if (isPremiumLocked) {
    return <PremiumDumbView {...props} />;
  }
}
